<h2 mat-dialog-title>{{ $title() }}</h2>
<div class="cm-dialog-content" mat-dialog-content [innerHtml]="$message()"></div>
@if (data.select; as select) {
    <div mat-dialog-content>
        <mat-form-field class="cm-dialog-select">
            <mat-label>{{ select.label }}</mat-label>
            <mat-select [value]="select.$value()" (valueChange)="select.$value.set($event)">
                @for (option of select.options; track option.value) {
                    <mat-option [value]="option.value">{{ option.label }}</mat-option>
                }
            </mat-select>
        </mat-form-field>
    </div>
}
<div mat-dialog-actions align="end">
    @if ($confirmLabel()) {
        <button mat-button [color]="$isDestructive() ? 'warn' : 'primary'" (click)="confirmAction()">{{ $confirmLabel() }}</button>
    }
    @if ($otherActions()) {
        @for (option of $otherActions(); track option.state) {
            <button mat-button (click)="confirmAction(option.state)">{{ option.label }}</button>
        }
    }
    @if ($cancelLabel()) {
        <button mat-button (click)="cancelAction()" autofocus>{{ $cancelLabel() }}</button>
    }
</div>
